module.exports = __webpack_public_path__ + "img/terroir-redshift-2.57f7688e.jpg";